// 必要な要素を取得
const snsContainer = document.querySelector(
  ".recommend-section"
);
const buttonWrapper = document.querySelectorAll(
  ".productDetail__button__container.sp"
);

// スクロール時の処理
window.addEventListener("scroll", function () {
  // SNSボタンの下までの位置
  const snsBottomPosition =
    snsContainer.getBoundingClientRect().top + window.scrollY;

  // 現在のスクロール位置
  const currentScrollPosition = window.scrollY + window.innerHeight;
  // スクロール位置がSNSボタンの下まで来たら
  if (currentScrollPosition > snsBottomPosition) {
    // isHiddenクラスを付与
    buttonWrapper[1].classList.add("isHidden");
  } else {
    // そうでない場合はisHiddenクラスを削除
    buttonWrapper[1].classList.remove("isHidden");
    buttonWrapper[1].classList.remove("fixed");
  }
});

let initialPosition;

window.addEventListener("scroll", function () {
  const buttonWrapper = document.querySelectorAll(
    ".productDetail__button__container.sp"
  );
  const addToCartBtnSP = buttonWrapper[1];

  // addToCartBtnSPに.fixedが付与されていない場合のみinitialPositionを取得
  if (!addToCartBtnSP.classList.contains("fixed")) {
    initialPosition = addToCartBtnSP.offsetTop;
  }

  const buttonHeight = addToCartBtnSP.offsetHeight;

  // addToCartBtnSP要素が画面内に入ったかどうかの判定
  if (window.scrollY + window.innerHeight > initialPosition + buttonHeight) {
    addToCartBtnSP.classList.add("fixed");
  } else {
    addToCartBtnSP.classList.remove("fixed");
  }
});
